import axios from 'axios';

const apiClient = axios.create({
  // baseURL: 'https://localhost:5208/api/',
  baseURL: 'https://api.mysfs24.com/api/', 
  headers: {
    "Content-Type": "application/json",
  },
});


apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;